import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/", 
      name: "home",
      component: Home
    },
    {
      path: "/home", 
      name: "homepage",
      component: Home
    },
    {
      path: "/rtap",
      name: "AboutRTap",

      component: () =>
        import("./views/R-Tap.vue")
    }
    ,
    {
      path: "/rtap/howitworks",
      name: "HowItWorks",
 
      component: () =>
        import("./views/RTapHowItWorks.vue")
    }
    ,
    {
      path: "/rtap/benefits",
      name: "Benefits",
 
      component: () =>
        import( "./views/RTapBenefits.vue")
    }
    ,
    {
      path: "/rtap/clients",
      name: "OurClients",

      component: () =>
        import( "./views/RTapClients.vue")
    }
    ,
    {
      path: "/smartmeter",
      name: "SmartMeter",

      component: () =>
        import( "./views/SmartMeter.vue")
    }
    ,
    {
      path: "/casestudies",
      name: "CaseStudies",

      component: () =>
        import( "./views/CaseStudies.vue")
    }
    ,
    {
      path: "/about",
      name: "about",
    
      component: () =>
        import( "./views/AboutUs.vue")
    }
    ,
    {
      path: "/about#ourimpact",
      name: "ourimpact",

      component: () =>
      import("./views/AboutUs.vue")
    }
    ,
    {
      path: "/about#awards",
      name: "awards",

      component: () =>
      import("./views/AboutUs.vue")
    },
    {
      path: "/about#theteam",
      name: "theteam",

      component: () =>
      import("./views/AboutUs.vue")
    }
    ,
    {
      path: "/about#footer-general",
      name: "footer",

      component: () =>
      import("./views/AboutUs.vue")
    }
    ,
    {
      path: '/contactus',
      component: () =>
      import("./views/ContactUs.vue")
    }
    ,
    {
      // will match everything
      path: '*',
      component: () =>
        import("./views/NotFound.vue")
    }
  ]
});
